<template>
 <v-container>
<v-row v-if="userData">
  <v-col cols="12">
    <h2>
      <router-link class="yesLink" to="/waizmanntabellen_bestellen">
        Sie sind jetzt eingeloggt - klicken Sie hier um WaizmannTabellen anzufordern
      </router-link>
    </h2>
  </v-col>
</v-row>

<v-row v-else>
  <v-col cols="12" md="6">
    <div class="login-split-box login-split-box--login">
      <span class="login-step login-step--login">1. Einloggen</span>
      <h2 class="login-split-title">Sie haben schon ein Login?</h2>
      <LoginView newRoute="/waizmanntabellen_bestellen" />
    </div>
  </v-col>

  <v-col cols="12" md="6">
    <div class="login-split-box login-split-box--register">
      <span class="login-step login-step--register">2. Kostenlos registrieren</span>
      <h2 class="login-split-title">Sie sind neu bei TeamWaizmann?</h2>
      <RegisterView newRoute="/waizmanntabellen_bestellen" />
    </div>
  </v-col>
</v-row>

  </v-container>
</template>

<script setup>
import { onMounted, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/userStore';
const updateDocumentHead = inject('updateDocumentHead');


import LoginView from '@/components/objects/user/LoginView.vue'
import RegisterView from '@/components/objects/user/RegisterView.vue'
const userStore = useUserStore();


const { userData } = storeToRefs(userStore)

onMounted(() => {
    updateDocumentHead(
      'TeamWaizmann | WaizmannTabellen anfordern',
      'TeamWaizmann | WaizmannTabellen anfordern'
    ) 
})
</script>

<style scoped>
.login-split-box {
  background: #ffffff;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(16, 42, 67, 0.06);
}

.login-split-box--login {
  border-top: 4px solid #3166a5;
}

.login-split-box--register {
  border-top: 4px solid #2e7d32;
}

.login-step {
  display: inline-block;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border-radius: 999px;
  padding: 5px 9px;
}

.login-step--login {
  color: #3166a5;
  background: rgba(49, 102, 165, 0.12);
}

.login-step--register {
  color: #2e7d32;
  background: rgba(46, 125, 50, 0.12);
}

.login-split-title {
  margin-top: 10px;
  margin-bottom: 12px;
  color: #1f3a63;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.25;
}

.login-split-subline {
  margin-top: -4px;
  color: #4a5568;
  margin-bottom: 12px;
}
</style>
